import React, { useMemo } from "react";
import { Card, Tabs } from "antd";
import { connect } from "dva";
import TabWithBadge from "@/components/TabWithBadge";
import IntegrationInfo from "./IntegrationInfo";
import ShipperInfo from "./ShipperInfo";
import TransporterInfo from "./TransporterInfo";

const { TabPane } = Tabs;

const ShipperTransporterIntegrationsCard = ({ adminShipmentView, isOpsAssistedChecked, handleToggleOpsAssisted }) => {
  const adminShipmentData = useMemo(() => adminShipmentView?.data, [adminShipmentView]);

  return (
    <Card style={{ minHeight: 500, marginBottom: 16 }}>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Shipper Info" key="shipper-info">
          <ShipperInfo />
        </TabPane>

        <TabPane tab="Transporter Info" key="transporter-info">
          <TransporterInfo
            isOpsAssistedChecked={isOpsAssistedChecked}
            handleToggleOpsAssisted={handleToggleOpsAssisted}
          />
        </TabPane>

        <TabPane
          key="integration-info"
          tab={
            <TabWithBadge title="Integration Info" color="purple" count={adminShipmentData?.integrationsCount ?? 0} />
          }
        >
          <IntegrationInfo />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default connect(({ adminShipmentView }) => ({
  adminShipmentView,
}))(ShipperTransporterIntegrationsCard);
